import generateAlphaId from '../../common/helpers/generate-alpha-id';

const generateCustomSchemeId = (colorType) => `ws-custom-${colorType}-${generateAlphaId()}`;

export default generateCustomSchemeId;
